import React, { useEffect, useState } from "react";
import { Box, Button, CardContent, Grid, Typography } from "@mui/material";
import { Card } from "react-bootstrap";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import ContactsIcon from "@mui/icons-material/Contacts";
import GraphicEqIcon from "@mui/icons-material/GraphicEq";
import VoiceChatIcon from "@mui/icons-material/VoiceChat";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import LanguageIcon from '@mui/icons-material/Language';
import SentimentDissatisfiedOutlinedIcon from '@mui/icons-material/SentimentDissatisfiedOutlined';
import SentimentNeutralOutlinedIcon from '@mui/icons-material/SentimentNeutralOutlined';
import SentimentSatisfiedOutlinedIcon from '@mui/icons-material/SentimentSatisfiedOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
// import CallingCreaditModal from "../../CallingCreaditModal";
import { useWorkspace } from "../../../../../contexts/WorkspaceContext";
import { getUsageDataForCallingAgent } from "../../../../../contexts/WorkspaceUtils";
import CommonToast from "../../../../Common_Components/CommonToast";
import CircularLoader from "../../Track_Website/CircularLoader";

const Usage = () => {
  const [expandedRows, setExpandedRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState("");
  const [iconType, setIconType] = useState("success");
  const [loading, setLoading] = useState(false);
  const [AllUsageData, setAllUsageData] = useState([])
  const [creditUsageThisMonth, setCreditUsageThisMonth] = useState(0)
  const {setShowCallingCreditsModal, remainingCredits, setRemainingCredits, fetchCallingCredits} = useWorkspace()

  const toggleRow = (index) => {
    if (expandedRows.includes(index)) {
      setExpandedRows(expandedRows.filter(i => i !== index));
    } else {
      setExpandedRows([...expandedRows, index]);
    }
  };

  const getAllUsageData = async () => {
    setLoading(true)
    try {
      // Use fetchCallingCredits instead of calling the API directly
      await fetchCallingCredits();
      
      // Get fresh data for the usage table
      const response = await getUsageDataForCallingAgent();
      const usageData = await response.json();
      
      if(usageData.status){
        // console.log("UsageData", usageData?.data?.monthly_data)
        setAllUsageData(usageData?.data?.monthly_data);
        setCreditUsageThisMonth(usageData?.data?.credit_used_current);
        // Remaining credits are already set by fetchCallingCredits
      } else {
        setOpen(true);
        setContent(usageData?.message);
        setIconType("error");
      }
    } catch(error) {
      console.log(error);
      setOpen(true);
      setContent(error?.message);
      setIconType("error");
    }
    setLoading(false);
  }

  useEffect(()=>{
    if(!AllUsageData.length){
      getAllUsageData()
    }
  },[])

  const handleToastClose = () => {
    setOpen(false);
  };

  function formatDate(isoString) {
    const date = new Date(isoString);
    
    const day = date.getDate();
    const monthNames = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    
    return `${day} ${month} ${year}`;
  }
  

  const data = [
    {
      Month: "January 2025",
      TotalCalls: "69",
      AverageDuration: "2 minutes",
      TotalDuration: "137.99 minutes",
      TotalCost: "USD 28.8",
      details: [
        { Date: "10 March 2025", TotalCalls: "69", AverageDuration: "2 minutes", TotalDuration: "137.99 minutes" },
        { Date: "11 March 2025", TotalCalls: "45", AverageDuration: "3 minutes", TotalDuration: "135 minutes" },
        { Date: "12 March 2025", TotalCalls: "32", AverageDuration: "4 minutes", TotalDuration: "128 minutes" }
      ]
    },
    {
      Month: "February 2025",
      TotalCalls: "45",
      AverageDuration: "3 minutes",
      TotalDuration: "135 minutes",
      TotalCost: "USD 22.5",
      details: [
        { Date: "10 February 2025", TotalCalls: "45", AverageDuration: "3 minutes", TotalDuration: "135 minutes" }
      ]
    },
    {
      Month: "March 2025",
      TotalCalls: "32",
      AverageDuration: "4 minutes",
      TotalDuration: "128 minutes",
      TotalCost: "USD 16.0",
      details: [
        { Date: "10 March 2025", TotalCalls: "32", AverageDuration: "4 minutes", TotalDuration: "128 minutes" }
      ]
    },
  ];

  return (
    <div>
      <Box  sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}>
      <Typography variant="h4" sx={{ marginBottom: "40px",  fontFamily:"Inter", fontSize:"24px", fontStyle:"normal", fontWeight:600, lineHeight:"20px", color:"#ffffff", opacity:0.90}}>
        Usage
      </Typography>
       <Box sx={{ display: "flex", flexDirection: "row", columnGap: "20px" }}>
      
                       {/* <Button
                                    onClick={()=>{setShowCallingCreditsModal(true)}}
                                    sx={{
                                      width: "160px",
                                      maxWidth: "160px",
                                      height: "40px",
                                      textTransform: "none",
                                      fontFamily: "Inter",
                                      fontSize: "16px",
                                      fontWeight: 600,
                                      textAlign: "center",
                                      bgcolor: "rgba(246, 190, 107, 1)",
                                      color: "rgba(23, 24, 44, 1)",
                                      borderRadius: "8px",
                                      "&:hover": {
                                        backgroundColor: "#ffd9aa",
                                      },
                                      // "&.Mui-disabled": {
                                      //   color: "rgba(230, 224, 233, 1)", // Custom color for the disabled state
                                      //   bgcolor:(subscribe && subscribeType === 4) ? "rgba(230, 224, 233, 0.12)" : "rgba(40, 45, 81, 1)"
                                      // },
                                    }}
                                  >
                                    Recharge credits
                        </Button> */}
        </Box>
      </Box>
      {/* Dashboard content goes here */}
      <Grid container spacing={5} justifyContent="start">
        <Grid item xs={3}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              border: "1px solid rgba(255, 255, 255, 0.10)",
              padding: "16px",
              justifyContent: "space-between",
              borderRadius: "16px",
              alignContent: "center",
              backgroundColor: "#171A2D",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                rowGap: "12px",
                padding: "0px",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "normal",
                  color: "rgba(255, 255, 255, 0.80)",
                }}
              >
                Credit balance
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "normal",
                  color: "rgba(255, 255, 255)",
                }}
              >
                {remainingCredits || 0}
              </Typography>
            </Box>
            <Box
              sx={{
                height: "40px",
                width: "40px",
                backgroundColor: "#282D51",
                paddingBottom: "0px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "0px",
                borderRadius: "100px",
              }}
            >
              <LocalPhoneIcon sx={{ padding: "0px" }} />
            </Box>
          </Box>
        </Grid>
        <Grid item xs={3}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              border: "1px solid rgba(255, 255, 255, 0.10)",
              padding: "16px",
              justifyContent: "space-between",
              borderRadius: "16px",
              alignContent: "center",
              backgroundColor: "#171A2D",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                rowGap: "12px",
                padding: "0px",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "normal",
                  color: "rgba(255, 255, 255, 0.80)",
                }}
              >
                Credits used this month
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "normal",
                  color: "rgba(255, 255, 255)",
                }}
              >
                {creditUsageThisMonth || 0}
              </Typography>
            </Box>
            <Box
              sx={{
                height: "40px",
                width: "40px",
                backgroundColor: "#282D51",
                paddingBottom: "0px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "0px",
                borderRadius: "100px",
              }}
            >
              <LocalPhoneIcon sx={{ padding: "0px" }} />
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          backgroundColor: "#171A2D",
          marginTop: "60px",
          padding: "20px",
        }}
      >
        <Box>
         <TableContainer>
        {
        loading ? 
           <CircularLoader  msg={"Loading Usage..."} /> 
        :
       
          <Table sx={{ fontFamily: "Inter", color: "#ffffff",  padding:"20px 24px", borderBottom:"1px solid rgba(255, 255, 255, 0.10)"  }}>
            <TableHead>
              <TableRow>
                <TableCell
                  align="left"
                  sx={{ fontFamily: "Inter", color: "#ffffff", fontSize:"16px", fontStyle:"normal", fontWeight:400, lineHeight:"28px",  padding:"20px 24px", borderBottom:"1px solid rgba(255, 255, 255, 0.10)"  }}
                >
                  Month
                </TableCell>
                <TableCell
                  align="left"
                  sx={{ fontFamily: "Inter", color: "#ffffff", fontSize:"16px", fontStyle:"normal", fontWeight:400, lineHeight:"28px",  padding:"20px 24px", borderBottom:"1px solid rgba(255, 255, 255, 0.10)"  }}
                >
                  Total calls
                </TableCell>
                <TableCell
                  align="left"
                  sx={{ fontFamily: "Inter", color: "#ffffff", fontSize:"16px", fontStyle:"normal", fontWeight:400, lineHeight:"28px",  padding:"20px 24px", borderBottom:"1px solid rgba(255, 255, 255, 0.10)"  }}
                >
                  Average duration
                </TableCell>
                <TableCell
                  align="left"
                  sx={{ fontFamily: "Inter", color: "#ffffff", fontSize:"16px", fontStyle:"normal", fontWeight:400, lineHeight:"28px",  padding:"20px 24px", borderBottom:"1px solid rgba(255, 255, 255, 0.10)"  }}
                >
                  Total duration
                </TableCell>
                {/* <TableCell
                  align="left"
                  sx={{ fontFamily: "Inter", color: "#ffffff", fontSize:"16px", fontStyle:"normal", fontWeight:400, lineHeight:"28px",  padding:"20px 24px", borderBottom:"1px solid rgba(255, 255, 255, 0.10)"  }}
                >
                  Total cost
                </TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {AllUsageData?.map((row, index) => (
                <React.Fragment key={index}>
                  <TableRow
                    sx={{ "&:last-child td, &:last-child th": { border: "none" } }}
                  >
                    <TableCell
                      align="left"
                      sx={{ fontFamily: "Inter", color: "#ffffff", fontSize:"16px", fontStyle:"normal", fontWeight:400, lineHeight:"28px",  padding:"20px 24px", borderBottom:"1px solid rgba(255, 255, 255, 0.10)"  }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {`${(row?.month) }`}
                        <Button 
                          onClick={() => toggleRow(index)}
                          sx={{ minWidth: 0, padding: 0 }}
                        >
                          {expandedRows.includes(index) ? 
                            <KeyboardArrowUpIcon sx={{ color: "#ffffff" }}/> : 
                            <KeyboardArrowDownIcon style={{ color: "#ffffff" }}/>
                          }
                        </Button>
                      </Box>
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{ fontFamily: "Inter", color: "#ffffff", fontSize:"14px", fontStyle:"normal", fontWeight:400, lineHeight:"28px",  padding:"20px 24px", borderBottom:"1px solid rgba(255, 255, 255, 0.10)" }}
                    >
                      <Box sx={{display:"flex", flexDirection:"row", columnGap:"10px", width:"120px", height:"36px", backgroundColor:"#1F233E", padding:"6px", borderRadius:"8px", alignItems:"center", justifyContent:"center"}}>
                      <Box sx={{fontFamily: "Inter", color: "#ffffff", fontSize:"14px", }}>{row?.total_calls}</Box>
                      </Box>
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{ fontFamily: "Inter", color: "#ffffff", fontSize:"16px", fontStyle:"normal", fontWeight:400, lineHeight:"28px",  padding:"20px 24px", borderBottom:"1px solid rgba(255, 255, 255, 0.10)"  }}
                    >
                      {row?.average_duration}
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{ fontFamily: "Inter", color: "#ffffff", fontSize:"16px", fontStyle:"normal", fontWeight:400, lineHeight:"28px",  padding:"20px 24px", borderBottom:"1px solid rgba(255, 255, 255, 0.10)"  }}
                    >
                      {row?.total_duration}
                    </TableCell>
                    {/* <TableCell
                      align="left"
                      sx={{ fontFamily: "Inter", color: "#ffffff", fontSize:"16px", fontStyle:"normal", fontWeight:400, lineHeight:"28px", padding:"20px 24px", borderBottom:"1px solid rgba(255, 255, 255, 0.10)"  }}
                    >
                      {row?.total_cost}
                    </TableCell> */}
                  </TableRow>
                  {expandedRows.includes(index) && (
                    <TableRow sx={{borderBottom:"none"}}>
                      <TableCell colSpan={5} sx={{ padding: 0, borderBottom:"none" }}>
                        <Box sx={{ 
                          display: 'flex',
                          width: '100%',
                          paddingBottom: '8px',
                          borderRadius: '16px',
                          border: '1px solid rgba(255, 255, 255, 0.10)',
                          background: 'rgba(20, 22, 38, 0.80)',
                          margin: '16px 0',
                          overflow: 'hidden',
                          borderBottom:"none"
                        }}>
                          <TableContainer>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell sx={{ 
                                    fontFamily: 'Inter',
                                    color: 'rgba(255, 255, 255, 0.80)',
                                    fontSize: '14px',
                                    fontStyle: 'normal',
                                    fontWeight: 400,
                                    lineHeight: 'normal',
                                    borderBottom: '1px solid rgba(255, 255, 255, 0.10)'
                                  }}>
                                    Date
                                  </TableCell>
                                  <TableCell sx={{ 
                                    fontFamily: 'Inter',
                                    color: 'rgba(255, 255, 255, 0.80)',
                                    fontSize: '14px',
                                    fontStyle: 'normal',
                                    fontWeight: 400,
                                    lineHeight: 'normal',
                                    borderBottom: '1px solid rgba(255, 255, 255, 0.10)'
                                  }}>
                                    Total calls
                                  </TableCell>
                                  <TableCell sx={{ 
                                    fontFamily: 'Inter',
                                    color: 'rgba(255, 255, 255, 0.80)',
                                    fontSize: '14px',
                                    fontStyle: 'normal',
                                    fontWeight: 400,
                                    lineHeight: 'normal',
                                    borderBottom: '1px solid rgba(255, 255, 255, 0.10)'
                                  }}>
                                    Average duration
                                  </TableCell>
                                  <TableCell sx={{ 
                                    fontFamily: 'Inter',
                                    color: 'rgba(255, 255, 255, 0.80)',
                                    fontSize: '14px',
                                    fontStyle: 'normal',
                                    fontWeight: 400,
                                    lineHeight: 'normal',
                                    borderBottom: '1px solid rgba(255, 255, 255, 0.10)'
                                  }}>
                                    Total duration
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody sx={{borderBottom:"none"}}>
                                {row?.daily_usage?.map((detail, detailIndex) => (
                                  <TableRow key={detailIndex}>
                                    <TableCell sx={{ 
                                      fontFamily: 'Inter',
                                      color: '#FFF',
                                      fontSize: '14px',
                                      fontStyle: 'normal',
                                      fontWeight: 400,
                                      lineHeight: '28px',
                                      borderBottom: '1px solid rgba(255, 255, 255, 0.10)'
                                    }}>
                                      {formatDate(detail?.date)}
                                    </TableCell>
                                    <TableCell sx={{ 
                                      fontFamily: 'Inter',
                                      color: '#FFF',
                                      fontSize: '14px',
                                      fontStyle: 'normal',
                                      fontWeight: 400,
                                      lineHeight: '28px',
                                      borderBottom: '1px solid rgba(255, 255, 255, 0.10)'
                                    }}>
                                      {detail?.total_calls}
                                    </TableCell>
                                    <TableCell sx={{ 
                                      fontFamily: 'Inter',
                                      color: '#FFF',
                                      fontSize: '14px',
                                      fontStyle: 'normal',
                                      fontWeight: 400,
                                      lineHeight: '28px',
                                      borderBottom: '1px solid rgba(255, 255, 255, 0.10)'
                                    }}>
                                      {detail?.average_duration}
                                    </TableCell>
                                    <TableCell sx={{ 
                                      fontFamily: 'Inter',
                                      color: '#FFF',
                                      fontSize: '14px',
                                      fontStyle: 'normal',
                                      fontWeight: 400,
                                      lineHeight: '28px',
                                      borderBottom: '1px solid rgba(255, 255, 255, 0.10)'
                                    }}>
                                      {detail?.total_duration}
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
      }
        </TableContainer>
      </Box>


      </Box>
      {/* <CallingCreaditModal /> */}
      <CommonToast
            open={open}
            onClose={handleToastClose}
            content={content}
            iconType={iconType}
            bgColor={"#282D51"}
          />
    </div>
  );
};

export default Usage;